import { render, staticRenderFns } from "./ResponseMassal.vue?vue&type=template&id=5a641c29&"
import script from "./ResponseMassal.vue?vue&type=script&lang=js&"
export * from "./ResponseMassal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports